import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form } from 'formsy-react'
import moment from 'moment'
import styled from 'styled-components'
import { Button, DatePicker } from 'advenio-components'
import AssistanceActions from '../../Data/Redux/AssistanceRedux'
import { ReportHeader, ReportContainer } from '../../Components/ReportsComponents'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${props => props.large ? 'row' : 'column'};
  padding: 16px;
  width: ${props => props.large ? '648px' : '400px'};
`

class Assistance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      start_date: null,
      end_date: null,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  onChange = (model) => {
    this.setState({ start_date: model.start_date, end_date: model.end_date })
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  download = () => {
    const { fromCenter, user, activeCenter} = this.props
    const { start_date, end_date} = this.state

    if(start_date === null  || end_date === null){
      return false
    }

    if ( fromCenter|| user.center_id !== undefined) {
      this.props.getAssistanceCenterExcel(
      this.state.start_date, this.state.end_date,'assistance', fromCenter !== undefined? activeCenter : user.center_id)
    } else {
      this.props.getAssistanceExcel(this.state.start_date, this.state.end_date,'assistance')
    }
  }

  render() {
    const { width } = this.state
    return (
      <ReportContainer>
        <ReportHeader>
          <span>Reporte de Asistencias</span>
        </ReportHeader>
        <Form
          onChange={this.onChange}
        >
          <Container large={width > 768}>
            <DatePicker
              name="start_date"
              label="Fecha inicio"
            //   value={}
            />
            <DatePicker
              name="end_date"
              label="Fecha Fin"
            //   value={}
            />
            <Button marginRight="0" marginLeft="10" danger small onClick={this.download}>
              Descargar
            </Button>
          </Container>
        </Form>
      </ReportContainer>
    )
  }
}


const mapStateToProps = ({ centersInfo,auth }) => ({
  activeCenter: centersInfo.center,
  user: auth.user
})

const mapDispatchToProps = dispatch => ({
  getAssistanceExcel: (start_date, end_date,path) =>
    dispatch(AssistanceActions.AssistanceExcelRequest(start_date, end_date,path)),
getAssistanceCenterExcel: (start_date, end_date, path, centerId) =>
    dispatch(AssistanceActions.AssistanceCenterExcelRequest(start_date,end_date,centerId,path)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Assistance))



// WEBPACK FOOTER //
// ./src/Containers/Reports/Assistance.jsx